class MapboxGlNotSupportedError extends Error {
  constructor(message, ...args) {
    super(message, ...args);
    this.message = 'Mapbox GL is not supported';
  }
}

export default MapboxGlNotSupportedError;
